export { default } from './ManageAccountMenu';
